
import { createReducer, createStandardAction } from 'typesafe-actions'

export enum RequestStatus {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success'
}

/**
 * Action for updating the request status
 */
export const requestStatusUpdate = createStandardAction(
  'REQUEST_STATUS/UPDATE')<RequestStatus>()

/**
 * Reducer for the request status
 */
export const requestStatus = createReducer(RequestStatus.LOADING).handleAction(requestStatusUpdate, ((state, {payload}) => payload))
